module.exports = __webpack_public_path__ + "img/2.52a24e85.jpg";